import { defineComponent as l, openBlock as n, createBlock as d, unref as i } from "vue";
import o from "./ghl-ui.es370.js";
const r = l({
  name: "UISwitch",
  inheritAttrs: !1
}), c = l({
  ...r,
  props: {
    checkedValue: {
      type: [String, Number, Boolean],
      default: !0
    },
    defaultValue: {
      type: [String, Number, Boolean]
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    loading: {
      type: Boolean,
      default: !1
    },
    rubberBand: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String
    },
    uncheckedValue: {
      type: [String, Number, Boolean],
      default: !1
    },
    value: {
      type: [String, Number, Boolean]
    }
  },
  setup(e) {
    return (u, a) => (n(), d(i(o), {
      "checked-value": e.checkedValue,
      "default-value": e.defaultValue,
      disabled: e.disabled,
      loading: e.loading,
      "rubber-band": e.rubberBand,
      size: e.size,
      "unchecked-value": e.uncheckedValue,
      value: e.value,
      "onUpdate:value": a[0] || (a[0] = (t) => u.$emit("update:value", t))
    }, null, 8, ["checked-value", "default-value", "disabled", "loading", "rubber-band", "size", "unchecked-value", "value"]));
  }
}), s = c;
export {
  s as default
};
